var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-container c-help--authCallback"},[_c('div',{staticClass:"l-container--inner"},[_c('load-indicator',{attrs:{"request":"signin-oidc"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }